export const isSuperEstablishment = (score: number): boolean => score > 50;
